import Vue from 'vue'
import Router from 'vue-router'
import { xwjStore } from './store/store'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function (location) {
    return originalPush.call(this, location).catch((err) => err)
}

let kejianrouter = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/Home.vue')
        },
        {
            path: '/news',
            name: 'news',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/News.vue'),
        },
        {
            path: '/NewsList',
            name: 'NewsList',
            meta: {
                naviPath: '/news',
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/NewsList.vue'),
        },
        {
            path: '/newsdetails',
            name: 'newsdetails',
            meta: {
                naviPath: '/news',
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/NewsDetails.vue'),
        },
        {
            path: '/about_us',
            name: 'about_us',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/about_us.vue'),
        },
        {
            path: '/contactUs',
            name: 'contactUs',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/contactUs.vue'),
        },
        {
            path: '/publications',
            name: 'publications',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/publications.vue'),
        },
        {
            path: '/registrationFees',
            name: 'registrationFees',
            meta: {
                naviPath: '/conference',
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/registrationFees.vue'),
        },
        {
            path: '/registrationInfo',
            name: 'registrationInfo',
            meta: {
                naviPath: '/conference',
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/registrationInfo.vue'),
        },
        {
            path: '/previousMeeting',
            name: 'previousMeeting',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/previousMeeting.vue'),
        },
        {
            path: '/conferenceHistoryDetail',
            name: 'conferenceHistoryDetail',
            meta: {
                naviPath: '/previousMeeting',
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/ConferenceHistoryDetail.vue'),
        },
        {
            path: '/case',
            name: 'case',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/Case.vue')
        },
        {
            path: '/conference',
            name: 'conference',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/conference.vue')
        },
        {
            path: '/submission',
            name: 'submission',
            meta: {
                naviPath: '/conference',
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/submission.vue')
        },
        {
            path: '/conference-registration',
            name: 'conferenceRegistration',
            meta: {
                naviPath: '/conference',
                showHeader: true,
                showFooter: true,
                requireAuth: true
            },
            component: () => import('./views/ConferenceRegistration.vue')
        },
        {
            path: '/my-registrations',
            name: 'myRegistrations',
            meta: {
                naviPath: '/conference',
                showHeader: true,
                showFooter: true,
                requireAuth: true
            },
            component: () => import('./views/MyRegistrations.vue')
        },
        {
            path: '/my-reviews',
            name: 'myReviews',
            meta: {
                naviPath: '/conference',
                showHeader: true,
                showFooter: true,
                requireAuth: true
            },
            component: () => import('./views/MyReviews.vue')
        },
        {
            path: '/review-detail',
            name: 'reviewDetail',
            meta: {
                naviPath: '/conference',
                showHeader: true,
                showFooter: true,
                requireAuth: true
            },
            component: () => import('./views/ReviewDetail.vue')
        },
        {
            path: '/ThemeDetails',
            name: 'ThemeDetails',
            meta: {
                naviPath: '/ThemeDetails',
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/ThemeDetails.vue')
        },
        {
            path: '/members',
            name: 'members',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/members.vue')
        },
        {
            path: '/download',
            name: 'download',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/Download.vue')
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                showHeader: false,
                showFooter: false
            },
            component: () => import('./views/Login.vue')
        },
        {
            path: '/pdf-upload-test',
            name: 'pdfUploadTest',
            meta: {
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/PdfUploadTest.vue')
        },
        {
            path: '/payPage',
            name: 'payPage',
            meta: {
                showHeader: false,
                showFooter: false
            },
            component: () => import('./views/payPage.vue')
        },
        {
            path: '/resetPass',
            name: 'resetPass',
            meta: {
                naviPath: '/',
                showHeader: true,
                showFooter: true
            },
            component: () => import('./views/resetPass.vue')
        },
        {
            path: '/admin',
            name: 'admin',
            meta: {
                requireAuth: true,
                showHeader: false,
                showFooter: false
            },
            component: () => import('./views/Admin.vue'),
            children: [
                {
                    path: '/admin/news',
                    name: 'new',
                    component: () => import('./views/Admin/News.vue')
                },
                {
                    path: '/admin/user',
                    name: 'user',
                    component: () => import('./views/Admin/User.vue')
                },
                {
                    path: '/admin/newsDetail',
                    name: 'newsDetail',
                    component: () => import('./views/Admin/newsDetail.vue')
                },
                {
                    path: '/admin/conferenceThemeDetail',
                    name: 'conferenceThemeDetail',
                    component: () => import('./views/Admin/conferenceThemeDetail.vue')
                },
                {
                    path: '/admin/conferenceDetail',
                    name: 'conferenceDetail',
                    component: () => import('./views/Admin/conferenceDetail.vue')
                },
                {
                    path: '/admin/VIP',
                    name: 'VIP',
                    component: () => import('./views/Admin/VIP.vue')
                },
                {
                    path: '/admin/memberBenefits',
                    name: 'memberBenefits',
                    component: () => import('./views/Admin/memberBenefits.vue')
                },
                {
                    path: '/admin/addMember',
                    name: 'addMember',
                    component: () => import('./views/Admin/addMember.vue')
                },
                {
                    path: '/admin/memberLevel',
                    name: 'memberLevel',
                    component: () => import('./views/Admin/memberLevel.vue')
                },
                {
                    path: '/admin/memberList',
                    name: 'memberList',
                    component: () => import('./views/Admin/memberList.vue')
                },
                {
                    path: '/admin/memberDetail',
                    name: 'memberDetail',
                    component: () => import('./views/Admin/memberDetail.vue')
                },
                {
                    path: '/admin/donateLevel',
                    name: 'donateLevel',
                    component: () => import('./views/Admin/donateLevel.vue')
                },
                {
                    path: '/admin/honor',
                    name: 'honor',
                    component: () => import('./views/Admin/Honor.vue')
                },
                {
                    path: '/admin/page',
                    name: 'page',
                    component: () => import('./views/Admin/Page.vue')
                },
                {
                    path: '/admin/Mission',
                    name: 'Mission',
                    component: () => import('./views/Admin/Mission.vue')
                },
                {
                    path: '/admin/Constitution',
                    name: 'Constitution',
                    component: () => import('./views/Admin/Constitution.vue')
                },
                {
                    path: '/admin/Board',
                    name: 'Board',
                    component: () => import('./views/Admin/Board.vue')
                },
                {
                    path: '/admin/Ethics',
                    name: 'Ethics',
                    component: () => import('./views/Admin/Ethics.vue')
                },
                {
                    path: '/admin/Awards',
                    name: 'Awards',
                    component: () => import('./views/Admin/Awards.vue')
                },
                {
                    path: '/admin/contactUs',
                    name: 'contactUs',
                    component: () => import('./views/Admin/contactUs.vue')
                },
                {
                    path: '/admin/branch',
                    name: 'branch',
                    component: () => import('./views/Admin/branch.vue')
                },
                {
                    path: '/admin/branchDetail',
                    name: 'branchDetail',
                    component: () => import('./views/Admin/branchDetail.vue')
                },
                {
                    path: '/admin/Journals',
                    name: 'Journals',
                    component: () => import('./views/Admin/Journals.vue')
                },
                {
                    path: '/admin/PublicationOfBooks',
                    name: 'PublicationOfBooks',
                    component: () => import('./views/Admin/PublicationOfBooks.vue')
                },
                {
                    path: '/admin/applicantList',
                    name: 'applicantList',
                    component: () => import('./views/Admin/applicantList.vue')
                },
                {
                    path: '/admin/currentConference',
                    name: 'currentConference',
                    component: () => import('./views/Admin/currentConference.vue')
                },
                {
                    path: '/admin/conferenceTheme',
                    name: 'conferenceTheme',
                    component: () => import('./views/Admin/conferenceTheme.vue')
                },
                {
                    path: '/admin/conferenceAmountSetting',
                    name: 'conferenceAmountSetting',
                    component: () => import('./views/Admin/ConferenceAmountV2.vue')
                },
                {
                    path: '/admin/historyConference',
                    name: 'historyConference',
                    component: () => import('./views/Admin/historyConference.vue')
        },
        {
            path: '/admin/orderManagement',
            name: 'orderManagement',
            component: () => import('./views/Admin/OrderManagement.vue')
        },
        {
            path: '/admin/paperReview',
            redirect: '/admin/conferenceWorkspace'
        },
        {
            path: '/admin/reviewerManagement',
            redirect: '/admin/conferenceWorkspace'
        },
        {
            path: '/admin/paymentReview',
            redirect: '/admin/conferenceWorkspace'
        },
        {
            path: '/admin/conferenceWorkspace',
            name: 'conferenceWorkspace',
            component: () => import('./views/Admin/ConferenceWorkspace.vue')
        },
        {
            path: '/admin/emailConfig',
            name: 'emailConfig',
            component: () => import('./views/Admin/EmailConfigList.vue')
        },
        {
            path: '/admin/emailConfig/edit',
            name: 'emailConfigEdit',
            component: () => import('./views/Admin/EmailConfigEdit.vue')
        }
            ]
        },
        // 移动端路由相关信息
        {
            path: '/mobileHome',
            name: 'mobileHome',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/mobileHome.vue')
        },
        {
            path: '/newsMobile',
            name: 'newsMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/newsMobile.vue')
        },
        {
            path: '/newsListMobile',
            name: 'newsListMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/newsListMobile.vue')
        },
        {
            path: '/newsDetailMobile',
            name: 'newsDetailMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/newsDetailMobile.vue')
        },
        {
            path: '/aboutUsMobile',
            name: 'aboutUsMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/aboutUsMobile.vue')
        },
        {
            path: '/caseMobile',
            name: 'caseMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/caseMobile.vue')
        },
        {
            path: '/conferenceMobile',
            name: 'conferenceMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/conferenceMobile.vue')
        },
        {
            path: '/registrationMobile',
            name: 'registrationMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/registrationMobile.vue')
        },
        {
            path: '/registrationFeesMobile',
            name: 'registrationFeesMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/registrationFeesMobile.vue')
        },
        {
            path: '/submissionMobile',
            name: 'submissionMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/submissionMobile.vue')
        },
        {
            path: '/publicationsMobile',
            name: 'publicationsMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/publicationsMobile.vue')
        },
        {
            path: '/contactUsMobile',
            name: 'contactUsMobile',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/contactUsMobile.vue')
        },
        {
            path: '/loginMobile',
            name: 'loginMobile',
            meta: {
                showHeader: false,
                showFooter: false,
                isMobile: true
            },
            component: () => import('./views/mobile/loginMobile.vue')
        },
        {
            path: '/passwordMobile',
            name: 'passwordMobile',
            meta: {
                showHeader: false,
                showFooter: false,
                isMobile: true
            },
            component: () => import('./views/mobile/forgetPassword.vue')
        },
        {
            path: '/mineMobile',
            name: 'mineMobile',
            meta: {
                showHeader: false,
                showFooter: false,
                isMobile: true
            },
            component: () => import('./views/mobile/mineMobile.vue')
        },
        {
            path: '/mineInfo',
            name: 'mineInfo',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/mineInfo.vue')
        },
        {
            path: '/mineShip',
            name: 'mineShip',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/mineShip.vue')
        },
        {
            path: '/mineConference',
            name: 'mineConference',
            meta: {
                showHeader: true,
                showFooter: true,
                isMobile: true
            },
            component: () => import('./views/mobile/mineConference.vue')
        }
    ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
    console.log(to,to.matched.some(res => res.meta.requireAuth))
    const ua = window.navigator.userAgent
    // 判断是否需要登录权限
    if (to.matched.some(res => res.meta.requireAuth)) {
        // 区分C端和B端：B端路径以/admin开头，C端路径不以/admin开头
        const isAdminRoute = to.path.startsWith('/admin')
        sessionStorage.setItem('isCuser', isAdminRoute ? '0' : '1')
        // 判断是否登录
        if (sessionStorage.getItem('token')) {
            next()
        } else {
            if (isAdminRoute) {
                // B端用户 - 跳转到/login，保存完整redirect（包括hash）
                const fullRedirect = to.fullPath + (to.hash || '')
                next({
                    path: '/login',
                    query: {
                        redirect: encodeURIComponent(fullRedirect)
                    }
                })
            } else {
                // C端用户 - 打开header登录dialog，不跳转页面
                const fullRedirect = to.fullPath + (to.hash || '')
                sessionStorage.setItem('loginRedirectPath', fullRedirect)
                // 取消当前导航，保持在原页面
                next(false)
                // 调用App.vue的getLogin打开登录弹窗
                const getLogin = xwjStore.get("getLogin")
                if (getLogin) {
                    getLogin()
                }
            }
        }
    } else{
        sessionStorage.setItem('isCuser', '1')

        if(to.matched.some(res => !res.meta.isMobile)&&/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua)){
            next({name:"mobileHome"})
        }else if(to.matched.some(res => res.meta.isMobile)&&!/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua)){
            next({name:"home"})
        }else {
            next()
        }
    }
})

export default kejianrouter
